
import { logger } from './../constants';
class State {
  constructor(val) {
    this.value = val;
  }
  toString() {
    return 'State ' + this.value;
  }
  equals(s) {
    return this.value == s.value;
  }
}

export const States = {
  INIT: new State(1),
  LOADING: new State(2),
  LOADED: new State(3),
  ERROR: new State(0)
};

export class StateLoader {
  constructor() {
    this.id = 'LDR-' + new Date().getTime();
    this.step = States.INIT;
    this.finals = [States.LOADED, States.ERROR];
  }
  get state() {
    return this.step;
  }
  updateState(s) {
    if (s && s instanceof State) {
      if (!this.finals.includes(this.step)) {
        this.step = s;
      } else {
        // eslint-disable-next-line no-console
        logger('StateLoader is on final step - can not update to a new step');
      }
    } else {
      // eslint-disable-next-line no-console
      console.warn('invalid parameter type for function StateLoader.updateState()');
    }
  }
}
